// @flow
import PatientModel from "src/models/PatientModel";
import { entityReducer } from "src/utils/reducerUtils";

export const patients = entityReducer({
  name: "patients",
  Model: PatientModel
});
